import { useQuery } from "@tanstack/react-query";

import { getRiskMatches } from "@/api/risk";
import { RiskQueryKeys } from "./riskQueryKeys";

// The viewer's risky-matches list. Polled every 30s; the socket listeners
// (couponsChanged, riskyMatchAlert) invalidate it in between.
export const useRiskMatches = () => {
  return useQuery({
    queryKey: [RiskQueryKeys.Matches],
    queryFn: ({ signal }) => getRiskMatches({ signal, params: { limit: 100 } }),
    refetchInterval: 30_000,
  });
};
